import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/app/model/store';

import { AnalyticsModel, AnalyticsModelSummary } from '../config';

type AnalyticsModelState = {
  analyticsModels: AnalyticsModelSummary[];
  analyticsModelById: Record<string, AnalyticsModel>;
  analyticsModelByIdLoading: Record<string, boolean>;
  loading: boolean;
  error: string | null;
};

const selectAnalyticsModelState = (state: RootState): AnalyticsModelState =>
  state.analyticsModel;

export const selectActiveAnalyticsModels = createSelector(
  selectAnalyticsModelState,
  (state) => state.analyticsModels.filter((model) => model.status === 'active'),
);

export const selectAllAnalyticsModels = createSelector(
  selectAnalyticsModelState,
  (state) => state.analyticsModels,
);

export const selectAnalyticsModelById = (id: string) =>
  createSelector(
    selectAnalyticsModelState,
    (state) => state.analyticsModelById[id],
  );

export const selectAnalyticsModelByCode = (code: string) =>
  createSelector(selectAnalyticsModelState, (state) =>
    state.analyticsModels.find(
      (model) => model.code === code && model.status !== 'deleted',
    ),
  );

export const selectAnalyticsModelByIdLoading =
  (id: string) => (state: RootState) =>
    selectAnalyticsModelState(state).analyticsModelByIdLoading[id] === true;

export const selectAnalyticsModelBySeriesId = (seriesId: string) =>
  createSelector(selectAnalyticsModelState, (state) =>
    state.analyticsModels.find((model) => model.series_id === seriesId),
  );

export const selectAnalyticsModelsLoading = createSelector(
  selectAnalyticsModelState,
  (state) => state.loading,
);

export const selectAnalyticsModelsError = createSelector(
  selectAnalyticsModelState,
  (state) => state.error,
);
